import { Injectable } from '@angular/core';
import { fromByteArray, toByteArray } from 'base64-js';
import { getIPromptOptionsKeys } from '../types/IPromptProfileMeta';
import { IPromptProfile } from '../types/prompt-profile';
import { BullhornDataService } from './bullhorn-data.service';

export interface IModelMap {
  oldModel: string;
  newModel: string;
}

@Injectable({
  providedIn: 'root',
})
export class PromptProfileService {

  public static modelList: IModelMap[] = [
    { oldModel: 'gpt-4-1106-preview', newModel: 'gpt-4-turbo' },
    { oldModel: 'claude-instant-1.2', newModel: 'claude-3-haiku' },
    { oldModel: 'gpt-3.5-turbo', newModel: 'gpt-4o-mini' },
    { oldModel: 'gpt-41', newModel: 'gpt-4.1' },
  ];

  constructor(private bullhornDataService: BullhornDataService) {}

  public encodePromptFields(prompt: IPromptProfile): IPromptProfile {
    const encoded = { ...prompt };
    if (encoded.additionalContext) {
      encoded.additionalContext = fromByteArray(new TextEncoder().encode(encoded.additionalContext));
    }
    if (encoded.description) {
      encoded.description = fromByteArray(new TextEncoder().encode(encoded.description));
    }
    if (encoded.LLMs && Array.isArray(encoded.LLMs)) {
      encoded.LLMs = JSON.stringify(encoded.LLMs);
    }
    if (encoded.noteFilter) {
      encoded.noteFilter = JSON.stringify(encoded.noteFilter);
    }
    if (encoded.fileFilter) {
      encoded.fileFilter = JSON.stringify(encoded.fileFilter);
    }
    getIPromptOptionsKeys().forEach((field) => {
      if (encoded[field]) {
        (encoded[field] as string) = JSON.stringify(encoded[field]);
      }
    });
    if (encoded.sourceFields) {
      encoded.sourceFields = JSON.stringify(encoded.sourceFields);
    }
    return encoded;
  }

  public decodePromptFields(prompt: IPromptProfile): void {
    if (prompt.additionalContext) {
      prompt.additionalContext = new TextDecoder().decode(toByteArray(prompt.additionalContext));
    }
    if (prompt.description) {
      prompt.description = new TextDecoder().decode(toByteArray(prompt.description));
    }
    if (prompt.entityType) {
      prompt.entityType = this.bullhornDataService.toBullhornEntity(prompt.entityType);
    }
  }

  public transformPrompt(prompt: IPromptProfile): IPromptProfile {
    this.decodePromptFields(prompt);
    if (prompt.LLMs) {
      prompt.LLMs = this.updateLLMs(prompt.LLMs);
    }
    return prompt;
  }

  public updateLLMs(LLMs: string[]): string[] {
    for (const model of PromptProfileService.modelList) {
      const { oldModel, newModel } = model;
      const oldIndex = LLMs.indexOf(oldModel);
      const newIndex = LLMs.indexOf(newModel);

      if (oldIndex !== -1) {
        LLMs[oldIndex] = newModel;
        // todo is this necessary
        if (newIndex !== -1 && newIndex !== oldIndex) {
          LLMs.splice(newIndex, 1);
        }
      }
    }
    return LLMs;
  }

  public createPromptRequest(promptProfile: IPromptProfile): IPromptProfile {
    const promptRequest = JSON.parse(JSON.stringify(promptProfile));
    getIPromptOptionsKeys().forEach((key) => {
      if (key in promptRequest) {
        if (Array.isArray(promptRequest[key])) {
          promptRequest[key] = promptRequest[key][0];
        }
        if (promptRequest[key] === '<blank>') {
          promptRequest[key] = '';
        }
      }
    });
    return promptRequest;
  }
}
